import api from "@/lib/api";

export const createPropFirm = async (formData) => {
  const res = await api.post("/prop-firms/create", formData);
  return res.data;
};

export const updatePropFirm = async (formData) => {
  const res = await api.post("/prop-firms/update", formData);
  return res.data;
};

export const getPropFirmById = async (id) => {
  const res = await api.get(`/prop-firms/${id}`);
  return res.data;
};

export const getAllPropFirms = async () => {
  const res = await api.get(`/prop-firms/getAllFirmsForAdminList`);
  return res.data;
};

export const deletePropFirm = async (id) => {
  const res = await api.delete(`/prop-firms/delete/${id}`);
  return res.data;
};